/* Warmtefonds-rekenhulp, richting B van 17 okt (keuze Luc, 19 okt 2026): de klant kiest hier geen systeem, net als
   in de calculator. Het blok rekent met het systeem uit "Bereken mijn batterij": sections/bv-configurator.liquid zet
   dat in sessionStorage "bv-wf-systeem" ({ variant, prijs, fase }). Daarna stap voor stap: eigenaar, inkomen en
   leenbedrag; elke stap verschijnt pas als de vorige is beantwoord. Niets vooraf ingevuld; de uitkomst verschijnt pas
   na "Bereken mijn maandbedrag" en rekent daarna mee. Zonder berekening staan dezelfde vragen er ook, met bovenaan
   een link naar de calculator (Luc, 19 okt 2026). Naam en maat komen uit de winkel (JSON in sections/bv-warmtefonds.liquid).

   Bronnen, warmtefonds.nl, gelezen 16 okt 2026: maximaal 8.500 euro voor een thuisbatterij, looptijd 7, 10 of
   15 jaar, 0 procent onder een gezamenlijk verzamelinkomen van 60.000 euro, anders de effectieve jaarrente
   hieronder (stand 12 oktober 2026, /particulieren/actuele-rentetarieven). Maandbedrag als annuiteit, gelijk
   aan de offerte (sjablonen/offerte.js); getoetst aan zes voorbeelden van het fonds, op een paar cent na gelijk.
   De sitecontrole vergelijkt RENTE elke keer met warmtefonds.nl (warmtefonds_rente() in sitecontrole.py).
   Wijzigt het fonds de rente: RENTE en RENTE_DATUM hier en in sjablonen/offerte.js bijwerken. */
(function () {
  'use strict';

  var MAX = 8500;
  var RENTE = [[7, 0.0457], [10, 0.0460], [15, 0.0493]];
  var RENTE_DATUM = '12 oktober 2026';

  function euro(n) { return '€ ' + Math.round(n).toLocaleString('nl-NL'); }
  function euro2(n) { return '€ ' + n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function pct(j) { return (j * 100).toLocaleString('nl-NL', { minimumFractionDigits: 2 }) + '%'; }
  function mnd(P, j, n) { if (!j) return P / n; var r = Math.pow(1 + j, 1 / 12) - 1; return P * r / (1 - Math.pow(1 + r, -n)); }
  function veilig(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* "7.350", "7350", "€ 7.350,00" en "7 350" worden allemaal 7350; centen vallen weg */
  function leesBedrag(t) {
    var s = String(t || '').replace(/[€\s]/g, '');
    if (s.indexOf(',') >= 0) s = s.split(',')[0];
    s = s.replace(/\./g, '');
    return /^\d+$/.test(s) ? parseInt(s, 10) : (s === '' ? null : NaN);
  }

  function init() {
    var wortel = document.querySelector('[data-bv-warmtefonds]');
    if (!wortel) return;
    var SETS = [];
    try { SETS = JSON.parse(wortel.querySelector('[data-bv-wf-sets]').textContent); } catch (e) { SETS = []; }
    var form = wortel.querySelector('[data-bv-wf-form]');
    var stap = function (n) { return form.querySelector('[data-bv-wf-stap="' + n + '"]'); };
    var nee = form.querySelector('[data-bv-wf-nee]');
    var bedragVeld = form.querySelector('[data-bv-wf-bedrag]');
    var melding = form.querySelector('[data-bv-wf-melding]');
    var knop = form.querySelector('[data-bv-wf-reken]');
    var uit = form.querySelector('[data-bv-wf-uitkomst]');
    var berekend = false;

    var sys = null;
    try { sys = JSON.parse(sessionStorage.getItem('bv-wf-systeem') || 'null'); } catch (e) { sys = null; }
    var set = null;
    if (sys && sys.variant) for (var i = 0; i < SETS.length; i++) if (String(SETS[i].variant) === String(sys.variant)) set = SETS[i];

    /* 19 okt 2026, Luc: de vragen staan er ook zonder berekening. Dan blijft de zin uit de sectie staan (met link
       naar de calculator), is er geen prijs en toetsen we het bedrag alleen aan het maximum van het fonds. */
    var prijs = null;
    if (set) {
      prijs = sys.prijs > 0 ? sys.prijs : set.prijs;
      form.querySelector('[data-bv-wf-systeem]').innerHTML =
        'We rekenen met <strong>' + veilig(set.naam) + ' · ' + veilig(set.kwh) + '</strong> voor <strong>' + euro(prijs) +
        '</strong> uit je berekening. <a href="/pages/samenstellen">Aanpassen</a>';
      form.querySelector('[data-bv-wf-bedrag-uitleg]').textContent =
        'Je batterij kost ' + euro(prijs) + '. Het Warmtefonds leent maximaal ' + euro(MAX) + '.';
    }

    function waarde(naam) { var el = form.querySelector('input[name="' + naam + '"]:checked'); return el ? el.value : null; }

    /* Welke stappen zichtbaar zijn volgt alleen uit de antwoorden; "Nee" bij eigenaar stopt het blok. */
    function toonStappen() {
      var eig = waarde('wf-eigenaar'), ink = waarde('wf-inkomen');
      nee.hidden = eig !== 'nee';
      stap(2).hidden = eig !== 'ja';
      stap(3).hidden = eig !== 'ja' || !ink;
      stap(4).hidden = stap(3).hidden;
      if (stap(3).hidden) { uit.innerHTML = ''; melding.hidden = true; }
    }

    function fout() {
      var b = leesBedrag(bedragVeld.value);
      if (b === null || b === 0) return 'Vul eerst in hoeveel je wilt lenen.';
      if (isNaN(b)) return 'Vul het bedrag in met alleen cijfers, bijvoorbeeld 7.500.';
      if (b > MAX) return 'Het Warmtefonds leent maximaal ' + euro(MAX) + ' voor een thuisbatterij.';
      if (prijs && b > prijs) return 'Je kunt niet meer lenen dan je batterij kost.';
      return null;
    }

    function reken() {
      var f = fout();
      if (f) { melding.textContent = f; melding.hidden = false; uit.innerHTML = ''; return; }
      melding.hidden = true;
      var leen = leesBedrag(bedragVeld.value);
      var eigen = prijs ? prijs - leen : 0;
      var laag = waarde('wf-inkomen') === 'laag';
      var tegels = RENTE.map(function (r) {
        var j = laag ? 0 : r[1];
        return '<div class="wfb-tegel"><span class="wfb-lab">' + r[0] + ' jaar' + (laag ? '' : ' · ' + pct(r[1])) + '</span>' +
          '<span class="wfb-bedrag">' + euro2(mnd(leen, j, r[0] * 12)) + '</span><span class="wfb-lab">per maand</span></div>';
      }).join('');
      uit.innerHTML =
        '<div class="wfb-uit" data-bv-wf-resultaat>' +
          '<h3>Je leent ' + euro(leen) + (laag ? ' met 0% rente' : ' met rente') + (eigen > 0 ? ', en legt zelf ' + euro(eigen) + ' bij' : '') + '</h3>' +
          '<div class="wfb-tegels">' + tegels + '</div>' +
          '<p class="wf-noot">Let op! Geld lenen kost geld. Afgeronde bedragen' + (laag ? '' : ', rente van ' + RENTE_DATUM) + '; het Warmtefonds berekent je exacte maandbedrag.</p>' +
          (set && sys.fase === 'weet-niet' ? '<p class="wf-noot">We rekenen met de 1-fase uitvoering; de installateur controleert je aansluiting bij de schouw.</p>' : '') +
          '<a class="btn btn-primair" href="/pages/samenstellen">Vraag je offerte aan</a>' +
        '</div>';
    }

    form.addEventListener('change', function () { toonStappen(); if (berekend && !stap(3).hidden) reken(); });
    bedragVeld.addEventListener('input', function () {
      if (berekend) reken();
      else if (!melding.hidden && !fout()) melding.hidden = true;
    });
    bedragVeld.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); knop.click(); } });
    knop.addEventListener('click', function () {
      berekend = true;
      reken();
      var doel = uit.firstChild || melding;
      if (doel && doel.getBoundingClientRect().bottom > window.innerHeight) doel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    toonStappen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
